export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g class=\"nc-icon-wrapper\"><polygon points=\"13,11 8,5 3,11 \"/></g></svg>";